export default __webpack_public_path__ + "static/media/logo.c93856b1.png";